import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Download, QrCode } from 'lucide-react';
import { useLang } from '../i18n';

const PDF_PATH = '/brochure/Intervantis-Transport-Solutions-2026-Brochure.pdf';

export const BrochureCTA = () => {
  const { t } = useLang();
  const siteUrl = process.env.REACT_APP_SITE_URL || (typeof window !== 'undefined' ? window.location.origin : '');
  const pdfUrl = `${siteUrl}${PDF_PATH}`;

  return (
    <div
      data-testid="brochure-cta"
      className="mt-12 rounded-2xl border border-white/10 bg-white/[0.03] p-6 flex flex-col sm:flex-row items-center gap-6"
    >
      {/* QR */}
      <div className="shrink-0 rounded-xl bg-white p-3 shadow-lg shadow-black/30">
        <QRCodeSVG
          value={pdfUrl}
          size={112}
          level="M"
          bgColor="#ffffff"
          fgColor="#0c2b31"
          data-testid="brochure-qr"
        />
      </div>

      {/* Text + download */}
      <div className="min-w-0 text-center sm:text-left">
        <div className="label-mono text-ember mb-2 flex items-center justify-center sm:justify-start gap-2">
          <QrCode size={14} /> {t('brochure.title')}
        </div>
        <p className="text-white/60 font-body text-sm leading-relaxed">{t('brochure.scan')}</p>
        <a
          href={PDF_PATH}
          download
          target="_blank"
          rel="noopener noreferrer"
          data-testid="brochure-download-btn"
          className="group mt-4 inline-flex items-center gap-2.5 rounded-full bg-ember hover:bg-ember-hover text-white px-5 py-3 label-mono shadow-lg shadow-ember/25 transition-colors"
        >
          <Download size={16} strokeWidth={2.1} className="transition-transform group-hover:translate-y-0.5" />
          {t('brochure.download')}
        </a>
        <div className="mt-2.5 label-mono text-white/35 text-[10px]">{t('brochure.note')}</div>
      </div>
    </div>
  );
};

export default BrochureCTA;
